import React from 'react'
import {
    Divider,
    Row,
    Form,
    Select,
    Button,
    Input,
    Switch,
    notification,
    Col,
    Spin,
    Tabs,
} from 'antd'
import { Link } from 'react-router-dom'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { onKeyPressNumbers } from '../../services/Utils'

const { TabPane } = Tabs
const { Option } = Select

const INIT = {
    name: '',
    code: '',
    main_warehouse_id: null,
    rfc: '',
    business_name: '',
    manager_id: '',
    address: '',
    zipcode: '',
    phone: '',
    suburb_id: '',
    active: true,
    created_at: '',
    updated_at: '',
    visible: false,
    logo_url: null,
    other_subsidiary: false,
}

const SubsidiariesCreateContainer = props => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [currentSearchManager, setCurrentSearchManager] = React.useState('')
    const [suburbs, setSuburbs] = React.useState([])
    const [subsidiary, setSubsidiary] = React.useState({
        id: '',
        name: '',
    })
    const disabled =
        !data.name ||
        !data.code ||
        !data.business_name ||
        !data.manager_id ||
        !data.phone ||
        !data.rfc ||
        !data.zipcode ||
        !data.address ||
        !data.suburb_id

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const getSuburbs = zipcode => {
        setloading(true)
        API.get('/api/suburbs/zipcode/' + zipcode)
            .then(response => {
                setloading(false)
                if (response.data && response.data.data) {
                    setSuburbs(response.data.data)
                }
            })
            .catch(error => {
                setloading(false)
                console.error(error)
            })
    }

    const handleSubmit = async e => {
        setloading(true)
        e.preventDefault()
        const newData = { ...data }
        if (data.other_subsidiary) {
            newData.subsidiary_id = subsidiary.id // Para clonar precios de la otra sucursal
        }
        try {
            const response = await API.post('/api/subsidiaries', newData)
            if (response) {
                setloading(false)
                setData(INIT)
                setCurrentSearchManager('')
                notification.success({
                    message: 'La sucursal se ha guardado exitosamente',
                })
            }
        } catch (error) {
            setloading(false)
            notification.error({ message: error.message })
        }
    }

    return (
        <Segment loading={loading}>
            <Form style={{ maxWidth: '600px', margin: 'auto' }}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Información general" key="1">
                        <Divider>Crear sucursal</Divider>
                        <p className="message">
                            Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben
                            ser llenados.
                        </p>
                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Usar precios de otra sucursal" hasFeedback>
                                    <Switch
                                        checked={data.other_subsidiary}
                                        onChange={value => {
                                            handleChange('other_subsidiary', value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            {data.other_subsidiary ? (
                                <Col lg={12} md={12} sm={24}>
                                    <Form.Item label="Precios de otra sucursal">
                                        <Search
                                            value={subsidiary.name}
                                            placeholder="Sucursal"
                                            onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                            onChange={(key, value) => {
                                                setSubsidiary(value)
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            ) : null}
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Nombre" className="required" hasFeedback>
                                    <Input
                                        placeholder="Nombre"
                                        value={data.name}
                                        onChange={e => {
                                            handleChange('name', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Código" className="required" hasFeedback>
                                    <Input
                                        placeholder="Código"
                                        value={data.code}
                                        onChange={e => {
                                            handleChange('code', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Nombre del negocio" className="required" hasFeedback>
                                    <Input
                                        placeholder="Nombre del negocio"
                                        value={data.business_name}
                                        onChange={e => {
                                            handleChange('business_name', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Gerente" className="required">
                                    <Search
                                        value={currentSearchManager}
                                        placeholder="Gerente"
                                        onSearch={value =>
                                            `/api/users?filter[active]=1&filter[role_id]=2&filter[full_name]=${value}`
                                        }
                                        label="full_name"
                                        onChange={(key, value) => {
                                            setData({ ...data, manager_id: key })
                                            setCurrentSearchManager(value.full_name)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Teléfono" className="required" hasFeedback>
                                    <Input
                                        placeholder="Teléfono"
                                        onKeyPress={onKeyPressNumbers}
                                        value={data.phone}
                                        onChange={e => {
                                            if (e.target.value.length <= 10) {
                                                handleChange('phone', e.target.value)
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="RFC" className="required" hasFeedback>
                                    <Input
                                        placeholder="RFC"
                                        value={data.rfc}
                                        onChange={e => {
                                            handleChange('rfc', e.target.value.toLocaleUpperCase())
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Código postal" className="required" hasFeedback>
                                    <Input
                                        placeholder="Código postal"
                                        value={data.zipcode}
                                        onKeyPress={onKeyPressNumbers}
                                        onChange={e => {
                                            const value = e.target.value

                                            if (value.length <= 5) {
                                                handleChange('zipcode', value)
                                            }

                                            if (value.length >= 5) {
                                                getSuburbs(value)
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Dirección" className="required" hasFeedback>
                                    <Input
                                        placeholder="Dirección"
                                        value={data.address}
                                        onChange={e => {
                                            handleChange('address', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={12}>
                                <Form.Item label="Colonia" className="required">
                                    <Select
                                        id="suburb_id"
                                        showSearch
                                        mode="default"
                                        style={{ width: '100%' }}
                                        value={data.suburb_id || undefined}
                                        placeholder="Colonia"
                                        optionFilterProp="children"
                                        notFoundContent={
                                            loading ? (
                                                <Spin style={{ margin: '0 auto' }} size="small" />
                                            ) : (
                                                'No hay resultados'
                                            )
                                        }
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={key => {
                                            handleChange('suburb_id', key)
                                        }}
                                    >
                                        {suburbs.map(d => (
                                            <Option key={d.id} value={d.id}>
                                                {d.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Usar logo de utilesa" hasFeedback>
                                    <Switch
                                        checked={!!data.logo_url}
                                        onChange={value => {
                                            handleChange('logo_url', value ? 'utilesa' : '')
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Visible en la web" hasFeedback>
                                    <Switch
                                        checked={data.visible}
                                        onChange={value => {
                                            handleChange('visible', value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Activo" hasFeedback>
                                    <Switch
                                        checked={!!data.active}
                                        onChange={value => {
                                            handleChange('active', value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </TabPane>
                </Tabs>
                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>
                    <Form.Item>
                        <Link to="/subsidiaries">
                            <Button icon="arrow-left">Regresar</Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" icon="save" disabled={disabled} onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default SubsidiariesCreateContainer
